import LOGGER from './logger';
import { UserRole } from '../constants/UserRole'
import { LOCALE_STORAGE_TOKEN_KEY } from "../../config";


/**
 * Pobiera token z localStorage i parsuje do jsona
 * 
 * @returns {JSON} token autoryzacyjny lub null jesli go nie ma w storage lub nie można go sparsować
 */
export const getAuthToken = () => {

    try {
        let flow24token = JSON.parse(localStorage.getItem(LOCALE_STORAGE_TOKEN_KEY));
        return flow24token;
    } catch (e) {
        //nie da się sparsowac tokena - logujemy i czyscimy
        LOGGER.error("Error parsing authorization token", e);
        clearAuthToken();
    }

    return null;
}

/**
 * Ustawia token autoryzacyjny do localStorage
 * 
 * @param {JSON} authToken 
 */
export const setAuthToken = (authToken) => {
    localStorage.setItem(
        LOCALE_STORAGE_TOKEN_KEY,
        JSON.stringify(authToken)
    );
}

/**
 * Czysci token autoryzacyjny z localStorage
 */
export const clearAuthToken = () => {
    localStorage.clear();
}

/**
 *  Dekoduje token autoryzacyjny
 * 
 * @param {*} authToken token autoryzacyjny
 * @returns zdekodowaną zawartość tokena autoryzacyjnego
 */
export const decodeAuthToken = (authToken) => {
    try {
        let payload = JSON.parse(atob(authToken.split('.')[1]));
        LOGGER.info("Authorization token payload", payload);
        return payload;
    } catch (e) {
        //problem z dekodowaniem
        LOGGER.error("Error decoding authorization token", e);
        return null;
    }
}

/**
 * Określa czy zawartość tokena zawiera podana role uzytkownika
 * 
 * @param {*} tokenPayload zawartość tokena autoryzacyjnego
 * @param {*} userRole rola uzytkownika jaka sprawdzamy
 * @returns true - jesli zawartość tokena zawiera podaną rolę, false - w innym przypadku
 */
export const isTokenPayloadInRole = (tokenPayload, userRole) => {

    if (!tokenPayload) {
        return false;
    }

    return tokenPayload.aud.includes(userRole);
}

/**
 * Określa czy token autoryzacyjny zawiera rolę adminiastratora
 * 
 * @param {*} authToken token autoryzacyjny
 * @requires true - jeśli token autoryzacyjny zawierą rolę administratora, false - w innym przypadku
 */
export const isAuthTokenInAdminRole = (authToken) => {

    let tokenPayload = decodeAuthToken(authToken);
    return isTokenPayloadInRole(tokenPayload, UserRole.ROLE_ADMIN);

}